const LMSNavbarData = [
  {
    key: "dashboard",
    name: "Dashboard",
    link: "dashboard",
    slug: 'dashboard',
  },
  {
    key: "loan_information",
    name: "Loan Information",
    link: "loan-information",
    slug: 'loan-information',
  },
  {
    key: "transactions",
    name: "Transactions",
    link: "transactions",
    slug: 'transactions',
  },
  {
    key: "reports",
    name: "Reports",
    link: "reports",
    slug: 'reports',
  },
];

export default LMSNavbarData;
